import React, { useState, useEffect, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import './SongDetail.css';
import { useTranslation } from 'react-i18next';

function importAll(r) { let images = {}; r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); }); return images; }
const images = importAll(require.context('../assets/images', false, /\.(png|jpe?g|svg)$/));

function SongDetail({ song, onBackClick, onPlayClick, isPlaying, isCurrent }) {
  const { i18n } = useTranslation();
  const [lyrics, setLyrics] = useState('');

  useEffect(() => { 
    if (song.lyricsFile) { 
      setLyrics(''); // Clear previous lyrics immediately
      import(`../lyrics/${song.lyricsFile}`)
        .then(res => fetch(res.default))
        .then(res => res.text())
        .then(text => setLyrics(text))
        .catch(err => console.error("Could not load lyrics:", err)); 
    } else { 
      setLyrics('No lyrics available for this song.'); 
    } 
  }, [song]);

  const animatedLyrics = useMemo(() => {
    return lyrics.split('\n').map((line, index) => (
      <span key={index} style={{ animationDelay: `${index * 50}ms` }}>
        {line}
      </span>
    ));
  }, [lyrics]);

  if (!song) return null;
  const isThisSongPlaying = isPlaying && isCurrent;

  return (
    <div className="song-detail-view">
      <div className="song-detail-header" style={{ backgroundColor: '#D2691E' }}>
        <button className="back-button" onClick={onBackClick}><i className="fas fa-arrow-left"></i></button>
        <img src={images[song.imageSrc]} alt={song.title[i18n.language]} className="song-detail-cover" />
        <div className="song-detail-info">
          <h1>{song.title[i18n.language]}</h1>
          <p>{song.artist[i18n.language]}</p>
        </div>
      </div>
      <div className="song-detail-body">
        <div className="song-detail-controls"><button className="detail-play-button" onClick={() => onPlayClick(song.id - 1)}><i className={isThisSongPlaying ? "fas fa-pause" : "fas fa-play"}></i></button></div>
        <div className="lyrics-section">{animatedLyrics}</div>
      </div>
    </div>
  );
}

export default SongDetail;